import React,{useState,useEffect} from 'react'
import Filter from 'components/home/filter'
import Beranda from 'components/home/beranda'
import Search from 'components/home/Search'
import SearchContainer from 'components/SearchContainer'
import './style.css'
import { useDispatch,useSelector } from 'react-redux'
import { getForumFilter } from 'redux/actions/forum'
export default function Home() {
    const dispatch = useDispatch()
    const [searchmodal, setsearchmodal] = useState(false)
    const persist = useSelector(state => state.persist)
    const reducer = useSelector(state => state.reducer)
    useEffect(() => {
        dispatch(getForumFilter())
    }, [])
    // console.log(`persist`, persist)
    return (
        <div>
            <div className='layout-container'>
                {searchmodal&&<div onClick={()=>setsearchmodal(false)} className='backdrop-search'></div>}
                {searchmodal&&<SearchContainer/>}

                <div className='home-grid'>
                    <div className='left-grid'>
                        <Filter/>
                    </div>
                    <div className='center-grid'>
                        <Beranda/>
                    </div>
                    <div className='right-grid'>
                        <Search setsearchmodal={setsearchmodal} searchmodal={searchmodal}/>
                    </div>
                </div>
            </div>
            <br/><br/><br/>
        </div>
    )
}
